if (!customElements.get('l20-ten-products')) {
  class L20TenProducts extends HTMLElement {
    connectedCallback() {
      this.variantSelects = [...this.querySelectorAll('[data-variant-select]')];
      this.handleChange = this.handleChange.bind(this);
      this.addEventListener('change', this.handleChange);

      this.querySelectorAll('[data-gallery]').forEach((gallery) => this.showGalleryImage(gallery, '1'));
      this.variantSelects.forEach((select) => {
        this.showVariant(select.closest('[data-product]'), select.value, false);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleChange);
    }

    handleChange(event) {
      if (event.target.matches('[data-color-control]')) {
        const gallery = event.target.closest('[data-gallery]');
        this.showGalleryImage(gallery, event.target.value);
        return;
      }

      if (event.target.matches('[data-variant-select]')) {
        this.showVariant(event.target.closest('[data-product]'), event.target.value, true);
      }
    }

    showGalleryImage(gallery, imageIndex) {
      if (!gallery) return;

      gallery.querySelectorAll('[data-image]').forEach((panel) => {
        const isActive = panel.dataset.image === imageIndex;
        panel.hidden = !isActive;
        panel.setAttribute('aria-hidden', String(!isActive));
        panel.classList.toggle('is-active', isActive);
      });
    }

    showVariant(product, variantIndex, announce) {
      if (!product) return;

      product.querySelectorAll('[data-variant]').forEach((variant) => {
        const isActive = variant.dataset.variant === variantIndex;
        variant.hidden = !isActive;
        variant.classList.toggle('is-active', isActive);

        if (isActive) {
          const checkedColor = variant.querySelector('[data-color-control]:checked');
          this.showGalleryImage(variant.querySelector('[data-gallery]'), checkedColor?.value || '1');
        }
      });

      const select = product.querySelector('[data-variant-select]');
      const liveRegion = product.querySelector('[data-live-region]');
      if (announce && liveRegion && select) {
        liveRegion.textContent = `${select.selectedOptions[0]?.text || ''} selected`;
      }
    }
  }

  customElements.define('l20-ten-products', L20TenProducts);
}
